var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploaded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4771_3937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.706 6.33343C11.8902 6.1277 11.8727 5.8116 11.667 5.6274C11.4613 5.44321 11.1452 5.46067 10.961 5.6664L8.71486 8.17519C8.25973 8.68355 7.95323 9.0241 7.69118 9.24436C7.44154 9.45418 7.29492 9.49992 7.16683 9.49992C7.03874 9.49992 6.89212 9.45418 6.64248 9.24436C6.38043 9.0241 6.07393 8.68355 5.61879 8.17519L5.03935 7.52798C4.85515 7.32224 4.53905 7.30478 4.33332 7.48898C4.12758 7.67317 4.11012 7.98927 4.29431 8.19501L4.89851 8.86986C5.32241 9.34337 5.67599 9.73832 5.99906 10.0099C6.34082 10.2971 6.70945 10.4999 7.16683 10.4999C7.62421 10.4999 7.99284 10.2971 8.33459 10.0099C8.65766 9.73833 9.01123 9.34339 9.43512 8.86989L11.706 6.33343Z",
    fill: "#38D687"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00016 0.833252C4.04212 0.833252 0.833496 4.04188 0.833496 7.99992C0.833496 11.958 4.04212 15.1666 8.00016 15.1666C11.9582 15.1666 15.1668 11.958 15.1668 7.99992C15.1668 4.04188 11.9582 0.833252 8.00016 0.833252ZM1.8335 7.99992C1.8335 4.59416 4.59441 1.83325 8.00016 1.83325C11.4059 1.83325 14.1668 4.59416 14.1668 7.99992C14.1668 11.4057 11.4059 14.1666 8.00016 14.1666C4.59441 14.1666 1.8335 11.4057 1.8335 7.99992Z",
    fill: "#38D687"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4771_3937"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploaded);
export default __webpack_public_path__ + "static/media/Uploaded.c16464b4fd8f9b902a0ace3ff111bae7.svg";
export { ForwardRef as ReactComponent };